if (!customElements.get('hollyconnect-form')) {
  class HollyConnectForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.status = this.querySelector('.hc-form__status');
      this.button = this.querySelector('[type="submit"]');
      this.honeypot = this.querySelector('[name="MiddleName"]');


      this.querySelectorAll('[data-hc-select-label]').forEach((wrapper) => {
        const native = wrapper.querySelector('.custom-select__native');
        if (!native) return;
        native.dataset.hcLabel = wrapper.dataset.hcSelectLabel;
        native.dataset.hcRequired = wrapper.dataset.hcSelectRequired;

        native.hcWrapper = wrapper;
      });

      this.fields = Array.from(this.querySelectorAll('[data-hc-label]'));

      this.form.addEventListener('submit', (event) => this.onSubmit(event));

      this.fields.forEach((field) => {
        field.addEventListener('blur', () => this.validateField(field));
        field.addEventListener('change', () => this.validateField(field));
      });
    }

    fieldValue(field) {
      if (field.type === 'checkbox') {
        return field.checked ? field.dataset.hcValueYes : field.dataset.hcValueNo;
      }
      return (field.value || '').trim();
    }

    validateField(field) {
      const value = this.fieldValue(field);
      let message = '';

      if (field.dataset.hcRequired === 'true' && (!value || (field.type === 'checkbox' && !field.checked))) {
        message = this.dataset.requiredError;
      } else if (field.type === 'email' && value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
        message = this.dataset.emailError;
      }

      const errorEl = this.querySelector(`[data-hc-error-for="${field.id}"]`);
      if (errorEl) {
        errorEl.textContent = message;
        errorEl.hidden = message === '';
      }
      field.setAttribute('aria-invalid', message !== '');
      if (field.hcWrapper) field.hcWrapper.classList.toggle('hc-invalid', message !== '');

      return message === '';
    }

    setStatus(message, type) {
      this.status.textContent = message;
      this.status.className = `hc-form__status hc-form__status--${type}`;
      this.status.hidden = false;
      this.status.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    async onSubmit(event) {
      event.preventDefault();

      const results = this.fields.map((field) => this.validateField(field));
      if (results.includes(false)) {
        const firstInvalid = this.fields.find((field) => field.getAttribute('aria-invalid') === 'true');
        if (firstInvalid) {
          firstInvalid.focus();

          const target = firstInvalid.offsetParent
            ? firstInvalid
            : this.querySelector(`[data-hc-error-for="${firstInvalid.id}"]`);
          if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return;
      }

      this.status.hidden = true;
      this.button.disabled = true;
      this.button.classList.add('btn--loading');

      try {
        const formData = new FormData();
        formData.append('FormTitle', this.dataset.formTitle);

        this.fields.forEach((field) => {
          const value = this.fieldValue(field);
          if (!value) return;

          if (field.dataset.hcEmail === 'true') {
            formData.append('Email', value);
          } else {
            formData.append(`TextValues[${field.dataset.hcLabel}]`, value);
          }
        });

        if (this.honeypot && this.honeypot.value.trim() !== '') {
          formData.append('MiddleName', this.honeypot.value.trim());
        }

        const response = await fetch(this.dataset.endpoint, { method: 'POST', body: formData });
        const result = await response.json();

        if (result.isSuccess === true && result.statusCode === 200) {
          this.form.hidden = true;
          this.setStatus(this.dataset.successMessage, 'success');
        } else {
          this.setStatus(result.message || this.dataset.errorMessage, 'error');
        }
      } catch (error) {
        this.setStatus(this.dataset.errorMessage, 'error');
      } finally {
        this.button.disabled = false;
        this.button.classList.remove('btn--loading');
      }
    }
  }

  customElements.define('hollyconnect-form', HollyConnectForm);
}
